export default function CompareAgents() {
  const agents = [
    {
      name: 'CSSBuy',
      tagline: 'Best for volume buyers',
      highlight: true,
      imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20brand%20identity%20photography%20with%20sage%20green%20and%20cream%20color%20palette%20abstract%20geometric%20shapes%20clean%20modern%20aesthetic%20on%20light%20background%20soft%20natural%20lighting%20editorial%20style&width=400&height=300&seq=agent-cssbuy&orientation=landscape',
    },
    {
      name: 'Kakobuy',
      tagline: 'Best for beginners',
      highlight: false,
      imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20brand%20identity%20photography%20with%20warm%20taupe%20and%20beige%20color%20palette%20abstract%20geometric%20shapes%20clean%20modern%20aesthetic%20on%20light%20background%20soft%20natural%20lighting%20editorial%20style&width=400&height=300&seq=agent-kakobuy&orientation=landscape',
    },
    {
      name: 'Superbuy',
      tagline: 'Best for small hauls',
      highlight: false,
      imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20brand%20identity%20photography%20with%20soft%20coral%20and%20cream%20color%20palette%20abstract%20geometric%20shapes%20clean%20modern%20aesthetic%20on%20light%20background%20soft%20natural%20lighting%20editorial%20style&width=400&height=300&seq=agent-superbuy&orientation=landscape',
    },
    {
      name: 'Oopbuy',
      tagline: 'Best for Europe',
      highlight: false,
      imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20brand%20identity%20photography%20with%20soft%20blue%20gray%20and%20cream%20color%20palette%20abstract%20geometric%20shapes%20clean%20modern%20aesthetic%20on%20light%20background%20soft%20natural%20lighting%20editorial%20style&width=400&height=300&seq=agent-oopbuy&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-foreground-950">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <span className="inline-block px-3 py-1 border border-background-50/20 text-background-50/70 text-xs font-medium rounded-full tracking-wider uppercase whitespace-nowrap">
              Verified Agents
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mt-4 leading-tight">
              Compare Spreadsheet<br />Agents
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-300 max-w-md lg:text-right">
            All spreadsheet links work across every agent. Pick the one that fits your shipping needs and budget.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {agents.map((agent) => (
            <a
              key={agent.name}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`group flex flex-col rounded-lg overflow-hidden transition-all cursor-pointer ${
                agent.highlight
                  ? 'ring-2 ring-primary-400 bg-background-50'
                  : 'bg-background-100/10 hover:bg-background-100/15'
              }`}
            >
              <div className="w-full aspect-[4/3] overflow-hidden">
                <img
                  src={agent.imageUrl}
                  alt={`${agent.name} Spreadsheet Agent`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h3 className={`text-lg font-heading font-bold whitespace-nowrap ${agent.highlight ? 'text-foreground-950' : 'text-background-50'}`}>
                  {agent.name}
                </h3>
                <p className={`text-sm mt-1 whitespace-nowrap ${agent.highlight ? 'text-foreground-600' : 'text-foreground-300'}`}>
                  {agent.tagline}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}